// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"d05c9e65","366":"c67eafa7","503":"35373074","846":"902d31f9"}[chunkId] + ".chunk.js";
};